export const KV_TOAST_EVENT = 'kv-toast';

export type KvToastVariant = 'success' | 'error' | 'info';

export interface KvToastDetail {
  variant: KvToastVariant;
  message: string;
}

export function emitToast(target: EventTarget, detail: KvToastDetail): void {
  target.dispatchEvent(
    new CustomEvent<KvToastDetail>(KV_TOAST_EVENT, {
      bubbles: true,
      composed: true,
      detail,
    })
  );
}

declare global {
  interface GlobalEventHandlersEventMap {
    [KV_TOAST_EVENT]: CustomEvent<KvToastDetail>;
  }
}
